import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { EmpresaService } from 'src/app/services/empresa.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-hoja-usuario-admin',
  templateUrl: './hoja-usuario-admin.component.html',
  styleUrls: ['./hoja-usuario-admin.component.scss'],
})
export class HojaUsuarioAdminComponent implements OnInit {
  public isLoadingResults = false;
  public lstClubes: any;
  public clubSelect: any;
  public searchString: string = '';
public usuario:any;

  constructor(
    public empresaSvc: EmpresaService,
    public usrSvc: UserService,
    public dialog: MatDialog,
    private alertify: AlertifyService
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.empresaSvc.getEmpresasDropdown().subscribe((clubLst) => {
      console.log(clubLst);
      this.lstClubes = clubLst;
    });
  }

  onEnter() {
    console.log('boton enter');
    this.getUsuario();
  }

  getUsuario() {
    this.usrSvc
      .getHojaUsuarioAdmin({
        empresaId: this.clubSelect,
        documento: this.searchString,
      })
      .subscribe((res) => {
        if (res) {
          console.log(res);
          this.usuario=res;
        } else {
          this.usuario=null;
          this.alertify.error(
            'No se ha encontrado el usuario, verifique la información e intentelo de nuevo'
          );
        }
      });
  }
}
